import { c as _c } from "react/compiler-runtime";
import { BetaChip } from "@components/common/beta-chip";
import { FontWeights, Link, Text } from "@flat-ui";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Box, Stack } from "@mui-wrapper";

/** Optional tooltip text to show when the action switch is not checked */
export const TOOLTIP_TEXT_NOT_CHECKED = "Activate for project";

/** Optional tooltip text to show when the action switch is checked */
export const TOOLTIP_TEXT_CHECKED = "Deactivate for project";
/** Renders feature settings property description, learn more link, action switch */
export function FeatureSettingLayout(t0) {
  const $ = _c(37);
  const {
    featureName,
    featureDescription,
    learnMoreUrl,
    shouldShowBetaBadge,
    actionComponent
  } = t0;
  const {
    isScreenMdOrSmaller,
    isScreenLg,
    isScreenXl,
    isScreenXs
  } = useMediaQueryList();
  const shouldStackTextContent = isScreenMdOrSmaller || isScreenLg || isScreenXl;
  const shouldWrapDescriptionLine = isScreenXs;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = shouldStackTextContent ? "column" : "row";
  const t3 = shouldStackTextContent ? "flex-start" : "center";
  let t4;
  if ($[1] !== t3) {
    t4 = {
      alignItems: t3,
      gap: 1,
      flex: 1,
      minWidth: 0
    };
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = shouldStackTextContent ? "100%" : "auto";
  let t6;
  if ($[3] !== t5) {
    t6 = {
      display: "flex",
      alignItems: "center",
      gap: 1,
      width: t5,
      minWidth: 0
    };
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      fontWeight: FontWeights.Bold
    };
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== featureName) {
    t8 = <Text variant="bodyM" sx={t7}>{featureName}</Text>;
    $[6] = featureName;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== shouldShowBetaBadge) {
    t9 = shouldShowBetaBadge && <BetaChip />;
    $[8] = shouldShowBetaBadge;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t6 || $[11] !== t8 || $[12] !== t9) {
    t10 = <Box sx={t6}>{t8}{t9}</Box>;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = shouldWrapDescriptionLine ? "wrap" : "nowrap";
  const t12 = shouldStackTextContent ? "100%" : "auto";
  let t13;
  if ($[14] !== t11 || $[15] !== t12) {
    t13 = {
      display: "flex",
      alignItems: "center",
      gap: 1,
      flexWrap: t11,
      width: t12,
      minWidth: 0
    };
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== featureDescription || $[18] !== shouldStackTextContent) {
    t14 = featureDescription && <Text variant="bodyM">{!shouldStackTextContent && " - "}{featureDescription}</Text>;
    $[17] = featureDescription;
    $[18] = shouldStackTextContent;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== learnMoreUrl) {
    t15 = learnMoreUrl && <Text variant="bodyM" sx={{
      whiteSpace: "nowrap"
    }}><Link href={learnMoreUrl} target="_blank" underline="always">Learn more</Link></Text>;
    $[20] = learnMoreUrl;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t13 || $[23] !== t14 || $[24] !== t15) {
    t16 = <Box sx={t13}>{t14}{t15}</Box>;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t10 || $[27] !== t16 || $[28] !== t2 || $[29] !== t4) {
    t17 = <Stack direction={t2} sx={t4}>{t10}{t16}</Stack>;
    $[26] = t10;
    $[27] = t16;
    $[28] = t2;
    $[29] = t4;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      display: "flex",
      alignItems: "center",
      flexShrink: 0
    };
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== actionComponent) {
    t19 = <Box sx={t18}>{actionComponent}</Box>;
    $[32] = actionComponent;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t17 || $[35] !== t19) {
    t20 = <Box sx={t1}>{t17}{t19}</Box>;
    $[34] = t17;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  return t20;
}